import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import * as interfaces from '../../../../static/interfaces'
import { IJsonResponse } from 'core/JsonApiSerializer'
import AgentLayoutEdit from '../_layouts/edit'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  position: 'position',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('range_tags', { scope: 'activerecord.models' }),
})

const RangeTagsEdit: React.FC<{
  range_tag: IJsonResponse
}> = props => {
  const { data: rangeTag } = agentService.getDataFromJson(props.range_tag)

  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const { flush } = await agentService.updateRangeTag({
        ...rangeTag,
        ...values,
      })
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/range_tags'
    },
    [rangeTag]
  )

  return (
    <AgentLayoutEdit
      model="range_tags"
      title={title}
      fields={FIELDS}
      indexLink="/agent/range_tags"
      formItems={
        <>
          <InputText
            required={true}
            name="name"
            defaultValue={rangeTag.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue={rangeTag.position}
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default RangeTagsEdit
